<template>
    <div class="Login__Page">
        <div class="is-flex is-flex-direction-row-reverse">
            <div class="Login__Page__Figure">
                <div class="img-responsive">
                    <img src="@/assets/login.svg" alt="">
                </div>
            </div>
            <div class="Login__Page__Form p-6 is-flex is-flex-direction-row
                is-align-items-center">
                 <section class="is-flex is-flex-direction-column">
                    <h1>איפוס סיסמה</h1>
                    <h3 class="subtitle">אנא הזן את כתובת האמייל שלך</h3>
                    <form
                        @submit.prevent="reset">
                        <b-field label="אימייל">
                            <b-input placeholder=""
                                v-model="email"
                                type="email"
                                validation-message="כתובת המייל שהוזנה אינה תקנית"
                                icon-right="close-circle"
                                icon-right-clickable
                                @icon-right-click="clearIconClick">
                            </b-input>
                        </b-field>

                        <b-button :loading="loading"
                            native-type="submit" type="is-primary">אפס סיסמה</b-button>
                            <router-link to="/login">חזור למסך ההתחברות</router-link>
                        <b-message v-if="isSent" class="mt-5" type="is-success">
                            העזרה בדרך! שלחנו לך מייל איפוס סיסמה לכתובת המייל.
                            <br />
                            במידה ולא קיבלת את כתובת המייל <a @click.prevent="reset" href="">לחץ כאן</a> לשליחה חוזרת
                        </b-message>
                    </form>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import AuthService from '@/services/AuthService';

const RECAPTCHA_SITE_KEY = '6Lds5wgtAAAAAEMfgkqeOCCdRSqtZe7Ui9i4oJfX';
const RECAPTCHA_ACTION = 'forgot_password';
const RECAPTCHA_SCRIPT_ID = 'recaptcha-enterprise-script';

export default {
    name: 'Forgot',
    data() {
        return {
            email: this.$route.query.email,
            loading: false,
            isSent: false,
            recaptchaPromise: null,
        };
    },
    mounted() {
        this.loadRecaptcha();
    },
    beforeDestroy() {
        this.unloadRecaptcha();
    },
    methods: {
        searchIconClick() {
            alert('You wanna make a search?');
        },
        clearIconClick() {
            this.email = '';
        },
        loadRecaptcha() {
            if (this.recaptchaPromise) {
                return this.recaptchaPromise;
            }
            this.recaptchaPromise = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.id = RECAPTCHA_SCRIPT_ID;
                script.src = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;
                script.onload = () => resolve();
                script.onerror = () => reject(new Error('Failed to load reCAPTCHA'));
                document.head.appendChild(script);
            });
            return this.recaptchaPromise;
        },
        unloadRecaptcha() {
            const script = document.getElementById(RECAPTCHA_SCRIPT_ID);
            if (script) {
                script.remove();
            }
            document.querySelectorAll('.grecaptcha-badge').forEach((el) => el.remove());
        },
        async getRecaptchaToken() {
            await this.loadRecaptcha();
            return new Promise((resolve, reject) => {
                if (!window.grecaptcha || !window.grecaptcha.enterprise) {
                    reject(new Error('reCAPTCHA not loaded'));
                    return;
                }
                window.grecaptcha.enterprise.ready(async () => {
                    try {
                        const token = await window.grecaptcha.enterprise
                            .execute(RECAPTCHA_SITE_KEY, { action: RECAPTCHA_ACTION });
                        resolve(token);
                    } catch (err) {
                        reject(err);
                    }
                });
            });
        },
        async reset() {
            if (!this.email) {
                return;
            }
            this.loading = true;
            try {
                const captchaToken = await this.getRecaptchaToken();
                await AuthService.forgotPassword({
                    email: this.email,
                    captchaToken,
                    captchaAction: RECAPTCHA_ACTION,
                });
                this.isSent = true;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss">
.Login__Page {
    & > div {
        height: 100vh;
    }
}
.Login__Page__Form {
    flex: 0 1 600px;

    section {
        width: 100%;

        h1 {
            font-size: 25px;
            text-align: right;
        }
        .subtitle {
            margin: 5px 0 20px 0;
            font-size: 17px;
            color: #7b7b7b;
        }

        .label {
            font-size: 15px;
            font-weight: normal;
            color: #505050;

            &:not(:last-child) {
                margin: 0;
            }
        }
        input {
                direction: ltr;
            }
        button {
            margin: 10px 0;
            width: 100%;
        }

        .message-body {
            border-width: 0 4px 0 0;
            padding: .6em .6em;
        }
    }
}
.Login__Page__Figure {
    flex: 1 1 300px;
    background-color: #F8F8F8;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
